import styled from 'foundations-theming/utils';

// styled.tbody is required here because the tr:last-child td descendant selector
// has no equivalent prop on TableBody.
export const StyledTableBody = styled.tbody.withConfig({
  displayName: "StyledTableBody"
})(["&&{background-color:", ";}&& tr:last-child td{border-block-end:none;}"], ({
  theme
}) => theme.color['fill-surface-default']);